import { render, staticRenderFns } from "./address-search.vue?vue&type=template&id=4c0d87fe"
import script from "./address-search.vue?vue&type=script&lang=ts"
export * from "./address-search.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {FilterAddressBlock: require('/vercel/path0/components/filter/address-block.vue').default})
